<app-mobile-filter
  (close)="onCloseModal()"
  (showResults)="onFilterSpaces()"
  (clearFilters)="onClearFilters()"
  emitCustomEventFromButton="true"
>
  <ng-container content>
    <!-- filtr po budynku -->
    <ion-col
      *ngIf="buildingServ.buildings.length > 1"
      class="ion-no-padding"
      size="12"
    >
      <ion-item lines="full" (click)="showBuildings = !showBuildings">
        <ion-label>{{ "SPACE.BUILDING" | translate }}</ion-label>
        <ion-icon
          slot="end"
          name="chevron-down"
          [@toggleRotate]="showBuildings ? 'active' : 'inactive'"
        ></ion-icon>
      </ion-item>
    </ion-col>
    <ion-col
      *ngIf="buildingServ.buildings.length > 1"
      class="ion-no-padding overflow-hidden"
      size="12"
      [@toggleHeight]="showBuildings ? 'active' : 'inactive'"
    >
      <ion-item
        *ngFor="let building of buildingServ.buildings"
        lines="none"
        (ionChange)="onFilterBuilding($event, building)"
      >
        <ion-checkbox slot="start" [checked]="building.checked"></ion-checkbox>
        <ion-label>{{ building.name }}</ion-label>
      </ion-item>
    </ion-col>
    <!-- filtr po poziomie -->
    <ion-col class="ion-no-padding" size="12">
      <ion-item lines="full" (click)="showLevel = !showLevel">
        <ion-label>{{ "SPACE.LEVEL" | translate }}</ion-label>
        <ion-text
          color="primary"
          *ngIf="
            spaceFilterServ.filterDetails.buildingListId.length == 0 &&
            buildingServ.buildings.length > 1
          "
        >
          {{ "CHOOSE_BUILDING" | translate }}
        </ion-text>
        <ion-icon
          *ngIf="
            spaceFilterServ.filterDetails.buildingListId.length > 0 &&
            spaceDateFilterService.filterLoadedFloors?.length > 0
          "
          slot="end"
          name="chevron-down"
          [@toggleRotate]="showLevel ? 'active' : 'inactive'"
        ></ion-icon>
        <ion-text
          color="primary"
          *ngIf="
            spaceFilterServ.filterDetails.buildingListId.length > 0 &&
            spaceDateFilterService.filterLoadedFloors?.length == 0
          "
        >
          {{ "SPACE.ROOM.NO_SPACES" | translate }}
        </ion-text>
      </ion-item>
    </ion-col>
    <ion-col
      class="ion-no-padding overflow-hidden"
      size="12"
      [@toggleHeight]="showLevel ? 'active' : 'inactive'"
    >
      <ng-container
        *ngIf="spaceDateFilterService.filterLoadedFloors.length > 0"
      >
        <ion-item
          *ngFor="let floor of spaceDateFilterService.filterLoadedFloors"
          lines="none"
          (ionChange)="onFilterFloor($event, floor)"
        >
          <ion-checkbox slot="start" [checked]="floor.checked"></ion-checkbox>
          <ion-label
            >{{ floor.name }}
            <ng-container
              *ngIf="spaceFilterServ.filterDetails.buildingList.length > 1"
            >
              ({{
                buildingServ.getBuildingName(floor.idBuilding)
              }})</ng-container
            >
          </ion-label>
        </ion-item>
      </ng-container>
    </ion-col>
    <!-- Filtr po space-type -->
    <ion-col
      class="ion-no-padding"
      size="12"
      *ngIf="dictionaryServ[options.subtypeSource]?.length > 0"
    >
      <ion-item lines="full" (click)="showSpaceType = !showSpaceType">
        <ion-label>{{ "BOOKING.SPACE_TYPE" | translate }} </ion-label>
        <ion-icon
          slot="end"
          name="chevron-down"
          [@toggleRotate]="showSpaceType ? 'active' : 'inactive'"
        ></ion-icon>
      </ion-item>
    </ion-col>
    <ion-col
      *ngIf="dictionaryServ[options.subtypeSource]?.length > 0"
      class="ion-no-padding overflow-hidden"
      size="12"
      [@toggleHeight]="showSpaceType ? 'active' : 'inactive'"
    >
      <ion-radio-group
        (ionChange)="onFilterSubtype($event)"
        [(ngModel)]="spaceDateFilterService.subtype"
      >
        <ion-item
          *ngFor="let equipment of dictionaryServ[options.subtypeSource]"
          lines="none"
        >
          <ion-radio
            [id]="!equipment.value ? 'standard' : ''"
            slot="start"
            [value]="equipment"
          ></ion-radio>
          <ion-label>{{ equipment.key }} </ion-label>
        </ion-item>
      </ion-radio-group>
    </ion-col>
    <!-- filtr po wyposażeniu -->
    <ion-col
      class="ion-no-padding"
      size="12"
      *ngIf="equipmentServ.equipments.length > 0"
    >
      <ion-item lines="full" (click)="showEquipment = !showEquipment">
        <ion-label>{{ "SPACE.ROOM.EQUIPMENT" | translate }} </ion-label>
        <ion-icon
          slot="end"
          name="chevron-down"
          [@toggleRotate]="showEquipment ? 'active' : 'inactive'"
        ></ion-icon>
      </ion-item>
    </ion-col>
    <ion-col
      *ngIf="equipmentServ.equipments.length > 0"
      class="ion-no-padding overflow-hidden"
      size="12"
      [@toggleHeight]="showEquipment ? 'active' : 'inactive'"
    >
      <ion-item
        *ngFor="let equipment of parsedEquipments"
        lines="none"
        (ionChange)="onFilterEquipment($event, equipment)"
      >
        <ion-checkbox slot="start" [checked]="equipment.checked"></ion-checkbox>
        <ion-label>{{ equipment.key }} </ion-label>
      </ion-item>
    </ion-col>
  </ng-container>
</app-mobile-filter>
